module.exports = __webpack_public_path__ + "img/app/home/img/icon-arrow-rg-press.05a55d82cda5908042d5eb17b4faba7b.png";